// Copyright ©️ 2026 eVolve MEP, LLC

import type { Shipment, ShipmentPaginated } from '@evolvemep/api-ts';

import type { EntityStatusBadgeProps, GetLabelAndColorArgs } from 'components/Mantine/EntityStatusBadge';
import { EditableStatusBadge } from 'components/Mantine/StatusEditor/EditableStatusBadge';
import { useShipments } from 'modules/Shop/Shipments/ShipmentsPage/useShipments';

type Props = Omit<EntityStatusBadgeProps<'Shipment'>, keyof GetLabelAndColorArgs<'Shipment'>> & {
  shipment: ShipmentPaginated;
  onShipmentUpdated: (updatedShipment: Shipment) => void;
  editable: boolean;
};

export const EditableShipmentStatusBadge = ({ shipment, onShipmentUpdated, ...props }: Props) => {
  const { updateShipment } = useShipments();

  return (
    <EditableStatusBadge
      customStatusTypeName="Shipment"
      statusId={shipment.shipmentStatusId ?? null}
      stateName={shipment.shipmentStateName}
      onAssignStatus={async (shipmentStatusId) =>
        updateShipment(shipment.shipmentId, { shipmentStatusId }).then(onShipmentUpdated)
      }
      {...props}
    />
  );
};
